import { PAX_MANIFEST_FETCH_DETAIL } from 'modules/bus/pax-manifest/detail/actions/fetchPaxManifestDetailAction';
import { PAX_MANIFEST_MARK_PASSENGER } from 'modules/bus/pax-manifest/detail/actions/markPassengerAction';
import { PAX_MANIFEST_UPDATE_MARKED_PASSENGERS } from 'modules/bus/pax-manifest/detail/actions/updateMarkedPassengersAction';
import { NOT_INITIALIZED } from 'modules/bus/shared/constants/apiStatuses';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

const initialState = {
  fetch: {
    status: NOT_INITIALIZED,
    errorTitle: '',
    errorMessage: '',
    passengers: [],
    vessel: {},
    markers: [],
  },
  update: {
    status: NOT_INITIALIZED,
    errorTitle: '',
    errorMessage: '',
    message: '',
  },
  markedPassengers: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PAX_MANIFEST_FETCH_DETAIL:
      return {
        ...initialState,
        fetch: { ...action.payload },
      };
    case PAX_MANIFEST_MARK_PASSENGER:
      return {
        ...state,
        markedPassengers: {
          ...state.markedPassengers,
          [action.passengerEntityId]: action.checked,
        },
      };
    case PAX_MANIFEST_UPDATE_MARKED_PASSENGERS:
      return {
        ...state,
        update: { ...action.payload },
        markedPassengers: {},
      };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
